import { alpha, createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0891b2',
      light: '#67e8f9',
      dark: '#155e75',
    },
    secondary: {
      main: '#059669',
      light: '#6ee7b7',
      dark: '#047857',
    },
    background: {
      default: '#f3f7f8',
      paper: '#fffdf8',
    },
    success: {
      main: '#16a34a',
    },
    text: {
      primary: '#123244',
      secondary: alpha('#123244', 0.76),
    },
  },
  shape: {
    borderRadius: 18,
  },
  typography: {
    fontFamily: [
      'Source Sans 3',
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontFamily: 'Lexend, Inter, sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.04em',
    },
    h2: {
      fontFamily: 'Lexend, Inter, sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.04em',
    },
    h3: {
      fontFamily: 'Lexend, Inter, sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.03em',
    },
    h4: {
      fontFamily: 'Lexend, Inter, sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h5: {
      fontFamily: 'Lexend, Inter, sans-serif',
      fontWeight: 700,
    },
    h6: {
      fontFamily: 'Lexend, Inter, sans-serif',
      fontWeight: 700,
    },
    subtitle1: {
      fontFamily: 'Lexend, Inter, sans-serif',
    },
    body1: {
      lineHeight: 1.55,
    },
    body2: {
      lineHeight: 1.5,
    },
    button: {
      textTransform: 'none',
      fontWeight: 700,
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 22,
          border: `1px solid ${alpha('#0f172a', 0.06)}`,
          boxShadow: '0 12px 32px rgba(18, 50, 68, 0.07)',
          backgroundImage: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          paddingInline: 18,
          minHeight: 44,
          minWidth: 0,
          whiteSpace: 'normal',
          lineHeight: 1.25,
        },
        contained: {
          boxShadow: '0 10px 20px rgba(8, 145, 178, 0.18)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 600,
          maxWidth: '100%',
        },
        label: {
          whiteSpace: 'normal',
          overflowWrap: 'anywhere',
          lineHeight: 1.2,
          display: 'block',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 18,
          alignItems: 'flex-start',
        },
        message: {
          fontSize: '0.98rem',
          minWidth: 0,
          whiteSpace: 'normal',
          overflowWrap: 'anywhere',
          wordBreak: 'break-word',
          lineHeight: 1.45,
        },
        action: {
          alignItems: 'flex-start',
          marginRight: 0,
          paddingTop: 2,
          paddingLeft: 12,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'medium',
        InputLabelProps: {
          shrink: true,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          whiteSpace: 'normal',
          overflow: 'visible',
          textOverflow: 'clip',
          lineHeight: 1.15,
          maxWidth: 'calc(100% - 24px)',
          pointerEvents: 'auto',
        },
        shrink: {
          whiteSpace: 'normal',
          overflow: 'visible',
          textOverflow: 'clip',
          lineHeight: 1.1,
          maxWidth: 'calc(133% - 32px)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          backgroundColor: alpha('#ffffff', 0.88),
        },
        input: {
          minWidth: 0,
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 44,
        },
        indicator: {
          height: 3,
          borderRadius: 999,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 700,
          fontFamily: 'Lexend, Inter, sans-serif',
          minHeight: 44,
          alignItems: 'flex-start',
          minWidth: 0,
          whiteSpace: 'normal',
          lineHeight: 1.15,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          overflowWrap: 'anywhere',
          wordBreak: 'break-word',
        },
      },
    },
  },
})

export default theme
